import { courseRuntimeUrl } from './courseRuntimeContext';
import api from '../httpClient';
import { encodeFlowSegment } from './helpers';

export type FlowCompanionSession = {
  id: number;
  flow_run_id: number;
  flow_name: string;
  is_active: boolean;
  turn_count: number;
  last_question_id: number | null;
  created_at: string;
  updated_at: string;
};

export type FlowCompanionMessage = {
  id: number;
  content: string;
  is_user: boolean;
  created_at: string;
  question_id: number | null;
  metadata: Record<string, unknown>;
};

export const flowCompanion = {
  getSession: (flowName: string, flowRunId: number) =>
    api.get<FlowCompanionSession>(courseRuntimeUrl(`/api/flows/${encodeFlowSegment(flowName)}/companion/session/`), {
      params: { flow_run_id: flowRunId },
    }),
  createSession: (flowName: string, flowRunId: number) =>
    api.post<FlowCompanionSession>(courseRuntimeUrl(`/api/flows/${encodeFlowSegment(flowName)}/companion/session/`), {
      flow_run_id: flowRunId,
    }),
  listMessages: (flowName: string, sessionId: number) =>
    api.get<FlowCompanionMessage[]>(
      courseRuntimeUrl(`/api/flows/${encodeFlowSegment(flowName)}/companion/session/${sessionId}/messages/`),
    ),
  sendMessage: (
    flowName: string,
    sessionId: number,
    data: {
      message: string;
      current_question_id?: number | null;
      current_response?: Record<string, unknown> | null;
    },
  ) =>
    api.post<FlowCompanionMessage>(
      courseRuntimeUrl(`/api/flows/${encodeFlowSegment(flowName)}/companion/session/${sessionId}/messages/`),
      data,
    ),
};
